// Avisos de segurança — páginas 47 e 48 do PDF, e disclaimer da pág. 2/4. Fiel ao material.
// Estes avisos são parte essencial do conteúdo e não podem ser removidos.

export const SAFETY_SHORT =
  "Este guia é educativo. Sintomas intensos, persistentes ou preocupantes pedem avaliação profissional.";

export const GUIA_E = [
  "Um material educativo.",
  "Um guia de consulta.",
  "Inspirado na Medicina Tradicional Chinesa.",
  "Voltado ao autocuidado consciente.",
];

export const GUIA_NAO_E = [
  "Um diagnóstico.",
  "Um tratamento médico.",
  "Uma prescrição.",
  "Um substituto para consultas com profissionais de saúde.",
];

export const URGENCIA = [
  "Dor forte ou repentina",
  "Falta de ar",
  "Desmaio ou confusão",
  "Dor no peito",
  "Sangramentos importantes",
  "Febre alta persistente",
];

export const AVALIACAO = [
  "Sintomas que persistem",
  "Perda de peso inexplicada",
  "Vômitos frequentes",
  "Alterações intestinais intensas",
  "Cansaço fora do comum",
  "Ansiedade ou tristeza prolongada",
];

export const LEVE_OBSERVACOES = [
  "Quando começou",
  "Horário em que aparece",
  "O que melhora ou piora",
  "Alimentos e sono",
  "Emoções associadas",
  "Medicamentos ou tratamentos em uso",
];

export const USE_ASSIM = [
  "Leia o órgão relacionado ao sinal.",
  "Observe hábitos e horários.",
  "Teste mudanças pequenas.",
  "Registre como o corpo responde.",
  "Procure apoio profissional quando necessário.",
];

export const EVITE_ASSIM = [
  "Se autodiagnosticar.",
  "Interromper tratamentos.",
  "Ignorar sintomas intensos.",
  "Usar chás em excesso.",
  "Trocar orientação médica por informação geral.",
];

export const REGRA_DE_OURO = "Se algo preocupa, persiste ou piora, busque avaliação profissional.";

export const AUTOCUIDADO_RESPONSABILIDADE = [
  "Observar",
  "Registrar",
  "Compartilhar",
  "Receber orientação",
  "Cuidar com segurança",
];

export const CICLO_COMPASSO = [
  "Observar",
  "Ajustar",
  "Acompanhar",
  "Aprender",
];

export const SAFETY_CLOSING = {
  regraDeOuro: "Se algo preocupa, persiste ou piora, busque avaliação profissional.",
  fraseResponsabilidade: "Cuidar de si não é adivinhar. É observar com gentileza e buscar apoio quando necessário.",
  fraseSeguranca: "Autocuidado verdadeiro une atenção, bom senso e gentileza com o próprio corpo.",
};

export const EVALUATION_SOURCE = { pdfPage: 49, printedPage: "47" };
export const USAGE_SOURCE = { pdfPage: 50, printedPage: "48" };
export const SAFETY_SOURCE = [47, 48];
